export default __webpack_public_path__ + "static/media/Group 1383.9d21fd25.svg";